import { put, takeLeading } from 'redux-saga/effects';
import jwtDecode from 'jwt-decode';

import authApi from 'api/authApi';
import userApi from 'api/userApi';

import {
  LOCATIONS,
  storageKey,
  LOGIN_TYPE,
} from 'constants/index';
import {
  apiErrorHandler,
  showSuccess,
} from 'utils';
import axiosClient from 'utils/axios';

import {
  LOGIN_INTRANET,
  LOGIN_INTRANET_SUCCESS,
  LOGIN_INTRANET_FAILED,
  LOGIN_EXTRANET,
  LOGIN_EXTRANET_SUCCESS,
  LOGIN_EXTRANET_FAILED,
} from './actionTypes';
import { GET_ME, GET_PROFILE_EXTRANET_SUCCESS } from '../profile/actionTypes';

function* loginIntranet({ payload }) {
  try {
    const {
      email,
      password,
      history,
    } = payload;

    const response = yield authApi.loginIntranet({ email, password });

    const { token } = response.payload;
    localStorage.setItem(storageKey.AUTHENTICATE_TOKEN, token);

    let isIntranet = true;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        // eslint-disable-next-line no-console
        console.log('Decoded token Intranet:', decoded);
        if (decoded && typeof decoded.isIntranet === 'boolean') {
          isIntranet = decoded.isIntranet;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to decode token:', err);
      }
    }

    localStorage.setItem(
      storageKey.LOGIN_TYPE,
      isIntranet ? LOGIN_TYPE.INTRANET : LOGIN_TYPE.EXTRANET,
    );

    axiosClient.defaults.headers.Authorization = `Bearer ${token}`;

    if (isIntranet) {
      yield put({ type: LOGIN_INTRANET_SUCCESS });
      showSuccess(response.message);
      yield put({ type: GET_ME, payload });
      if (history?.push) {
        history.push(LOCATIONS.LOCATION_LIST);
      } else {
        window.location.href = LOCATIONS.LOCATION_LIST;
      }
    } else {
      yield put({ type: LOGIN_EXTRANET_SUCCESS });
      showSuccess(response.message);
      const profileResponse = yield userApi.getProfileExtranet();
      yield put({
        type: GET_PROFILE_EXTRANET_SUCCESS,
        payload: {
          ...profileResponse.payload,
          isIntranet: false,
        },
      });
      if (history?.push) {
        history.push(LOCATIONS.DASHBOARD);
      } else {
        window.location.href = LOCATIONS.DASHBOARD;
      }
    }
  } catch (error) {
    let errors;

    if (error.response?.data?.errors?.length) {
      errors = error.response.data.errors;
    } else {
      apiErrorHandler(error);
    }
    yield put({
      type: LOGIN_INTRANET_FAILED,
      payload: errors,
    });
  }
}

function* loginExtranet({ payload }) {
  try {
    const {
      email,
      password,
      history,
    } = payload;

    const response = yield authApi.loginExtranet({ email, password });

    const { token } = response.payload;
    localStorage.setItem(storageKey.AUTHENTICATE_TOKEN, token);

    let isIntranet = false;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        // eslint-disable-next-line no-console
        console.log('Decoded token Extranet:', decoded);
        if (decoded && typeof decoded.isIntranet === 'boolean') {
          isIntranet = decoded.isIntranet;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to decode token:', err);
      }
    }

    localStorage.setItem(
      storageKey.LOGIN_TYPE,
      isIntranet ? LOGIN_TYPE.INTRANET : LOGIN_TYPE.EXTRANET,
    );

    axiosClient.defaults.headers.Authorization = `Bearer ${token}`;

    if (isIntranet) {
      yield put({ type: LOGIN_INTRANET_SUCCESS });
      showSuccess(response.message);
      yield put({ type: GET_ME, payload });
      if (history?.push) {
        history.push(LOCATIONS.LOCATION_LIST);
      } else {
        window.location.href = LOCATIONS.LOCATION_LIST;
      }
    } else {
      yield put({ type: LOGIN_EXTRANET_SUCCESS });
      showSuccess(response.message);
      const profileResponse = yield userApi.getProfileExtranet();
      yield put({
        type: GET_PROFILE_EXTRANET_SUCCESS,
        payload: {
          ...profileResponse.payload,
          isIntranet: false,
        },
      });
      if (history?.push) {
        history.push(LOCATIONS.DASHBOARD);
      } else {
        window.location.href = LOCATIONS.DASHBOARD;
      }
    }
  } catch (error) {
    let errors;

    if (error.response?.data?.errors?.length) {
      errors = error.response.data.errors;
    } else {
      apiErrorHandler(error);
    }
    yield put({
      type: LOGIN_EXTRANET_FAILED,
      payload: errors,
    });
  }
}

export default function* authSaga() {
  yield takeLeading(LOGIN_INTRANET, loginIntranet);
  yield takeLeading(LOGIN_EXTRANET, loginExtranet);
}
